// import { push } from 'connected-react-router';
import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import { GET_AUDIO_LIST, GetAudioListAction } from '../store/system/types';
import getAudioList, { IFile } from '../services/api/requests/getAudioList';
import { setLoader } from '../store/system/actions';
import { saveAllData } from '../store/entities/actions';
import { normalizeData } from '../utils/normalizer';
import { ActionTypes, PlayAudioAction } from '../store/entities/types';
import { selectData, selectFiles } from '../store/entities/selectors';

// TODO: fix any
function* fetchAudioWorker(action: GetAudioListAction): any {
  const { payload } = action;
  yield put(setLoader(true));
  try {
    const [response] = yield all([yield call(getAudioList, payload)]);

    if (response) {
      const data = normalizeData(response.data);
      yield put(saveAllData(data));
    }

    yield put(setLoader(false));
  } catch (e) {
    console.log(
      '%c ERROR: ',
      'font-weight:bold; background-color:yellow; color:navy; padding:5px;',
      e,
    );
    yield put(setLoader(false));
  }
}

// TODO: fix any
function* playAudioTrackWorker(action: PlayAudioAction): any {
  const idToPlay = action.payload;
  const files = yield select(selectFiles);
  const oldData = yield select(selectData);

  const updatedFiles = files?.map((file: IFile) => ({
    ...file,
    isPlaying: file.id === idToPlay,
  }));

  const data = {
    ...oldData,
    results: {
      ...oldData.results,
      files: [...updatedFiles],
      filters: [...oldData.results.filters],
    },
  };

  yield put(saveAllData(data));
}

export default function* mainSaga(): any {
  // TODO: fix any
  yield all([
    yield takeLatest(GET_AUDIO_LIST, fetchAudioWorker),
    yield takeLatest(ActionTypes.PLAY_AUDIO_TRACK, playAudioTrackWorker),
  ]);
}
